var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.988 14.28V9.816H23.22C23.388 10.572 23.52 11.28 23.52 12.276C23.52 19.128 18.924 24 12 24C5.376 24 0 18.624 0 12C0 5.376 5.376 0 12 0C15.24 0 17.952 1.188 20.028 3.132L16.62 6.444C15.756 5.628 14.244 4.668 12 4.668C8.028 4.668 4.788 7.968 4.788 12.012C4.788 16.056 8.028 19.356 12 19.356C16.596 19.356 18.288 16.176 18.6 14.292H11.988V14.28Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDisabled);
export default __webpack_public_path__ + "static/media/google_disabled.4e2c5fcb.svg";
export { ForwardRef as ReactComponent };